import classNames from 'classnames';
import React from 'react';

import { User } from '../types';

import styles from './UserAvatar.module.css';

export function UserAvatar({ user }: { user: User }) {
  const { avatarUrl, displayName = 'Unknown' } = user || {};
  let avatarFragment;

  if (avatarUrl) {
    avatarFragment = (
      <div
        className={styles.avatar}
        style={{
          backgroundImage: `url(${avatarUrl})`,
          backgroundPosition: 'center center',
          backgroundSize: 'cover',
        }}
        title={`${displayName}'s avatar`}
      />
    );
  } else {
    const initials = getInitials(user);

    avatarFragment = (
      <span className={classNames(styles.avatar, styles.avatarInitials)}>{initials}</span>
    );
  }

  return (
    <div
      className={classNames({
        [styles.avatarContainer]: true,
        [styles.showingInitials]: !avatarUrl,
      })}
    >
      {avatarFragment}
    </div>
  );
}

function getInitials(user: User) {
  if (!user) {
    return null;
  }
  let initialsParts = [user.firstName, user.lastName].filter(Boolean);

  if (initialsParts.length === 0 && user.displayName) {
    initialsParts = user.displayName.split(' ');
  }

  initialsParts = initialsParts.slice(0, 2);

  const initials = initialsParts
    .filter(Boolean)
    .map((s) => s && s[0])
    .join('')
    .toUpperCase();
  if (!initials) return null;

  return initials;
}

export default UserAvatar;
